import { filtersThemeFields } from '../../../_common/platform/tsx/filtering/Constants';

export const name: string = 'Attribute Filter';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-filter-attributes';
export const icon: string = 'filter';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-filter-attributes'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)
export const priority: number = 11; //Priorty making widget be loaded earlier. The bigger the earlier.

export const themeFields = {
    section_Buttons: 'attribute-filter-buttons',
    verticalSpacing: 'attribute-filter-vertical-spacing',
    justifyButtons: 'attribute-filter-justify-toolbar-buttons',
    showResetButton: 'attribute-filter-show-reset-button',
    resetButtonShowMode: 'attribute-filter-reset-button-show-mode',
    showApplyButton: 'attribute-filter-show-apply-button',
    showRefreshButton: 'attribute-filter-show-refresh-button',
    refreshButtonShowMode: 'attribute-filter-refresh-button-show-mode',
    buttonsPosition: 'attribute-filter-toolbar-buttons-position',
    resetButtonMode: 'attribute-filter-reset-button-mode',
    componentMinWidth: 'attribute-filter-horizontal-component-min-width',
    componentMaxWidth: 'attribute-filter-horizontal-component-max-width',
    labelWidth: 'attribute-filter-label-width',
    titlePosition: filtersThemeFields.titlePosition,
    showClickToFilterAttributes: filtersThemeFields.showClickToFilterAttributes
};
